import * as React from "react";
import { SVGProps } from "react";
const Success = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 81 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} width={80} height={80} rx={40} fill="#F4F4F1" />
    <path
      d="M52.5 32L36.4961 48L28.5 40.0059"
      stroke="currentColor"
      strokeWidth={4}
    />
  </svg>
);
export default Success;
